let wsUp = true;
let apiUp = true;
const listeners = [];

function emit() {
  const u = !wsUp || !apiUp;
  listeners.forEach((l) => l(u));
}

export function isUnavailable() {
  return !wsUp || !apiUp;
}

export function setWsUp(v) {
  if (wsUp !== v) {
    wsUp = v;
    emit();
  }
}

export function setApiUp(v) {
  if (apiUp !== v) {
    apiUp = v;
    emit();
  }
}

export function resetConnectivity() {
  wsUp = true;
  apiUp = true;
  emit();
}

export function onUnavailableChange(l) {
  listeners.push(l);
  return () => {
    const i = listeners.indexOf(l);
    if (i >= 0) listeners.splice(i, 1);
  };
}
